



















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { getAppleAppStoreLink, getGooglePlayStoreLink } from '@utils/analytics';
import { isIphone, isMobileOS } from '@utils/client';
import { getReviewsData } from '@api/prismic';
import { HeaderStyle } from 'types/header';
import { marketingLinks } from '../links';
import MobileNavTemplate from '@components/header/navigation/mobile/mobile-nav-template.vue';
import NavigationLinkMobile from '@components/header/navigation/mobile/navigation-link-mobile.vue';
import RatingsStars from '@components/marketing-site/ratings-stars.vue';

@Component({
	components: {
		MobileNavTemplate,
		NavigationLinkMobile,
		RatingsStars
	}
})
export default class MobileNav extends Vue {
	@Prop()
	styles!: HeaderStyle;

	appBasePath = process.env.VUE_APP_BASE_PATH;

	appCloudfrontPath = process.env.VUE_APP_CLOUDFRONT_DOMAIN;

	appStoreLink = getAppleAppStoreLink('flyout_menu_smart_banner');
	playStoreLink = getGooglePlayStoreLink('flyout_menu_smart_banner');

	marketingLinks = marketingLinks;

	mobileAppProps = {
		ratingAverage: '',
		numberOfRatings: '',
		storeLink: ''
	};

	get isMobileOS(): boolean {
		return isMobileOS();
	}

	get isIphone(): boolean {
		return isIphone();
	}

	get isIraLandingPage(): boolean {
		return this.$route?.name === 'ira-landing';
	}

	get loginCtaClass(): string {
		return this.isIraLandingPage ? 'col-12' : 'col-6';
	}

	public async created(): Promise<void> {
		const reviewsData = await getReviewsData();

		this.mobileAppProps = {
			ratingAverage: this.isIphone ? reviewsData.iphone_app_rating : reviewsData.android_app_rating,
			numberOfRatings: this.isIphone
				? reviewsData.iphone_app_number_of_reviews
				: reviewsData.android_app_number_of_reviews,
			storeLink: this.isIphone ? this.appStoreLink : this.playStoreLink
		};
	}
}
